import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

import DockwaPlusBadge from "./DockwaPlusBadge"

const Discount = ({
  label,
  amount,
  source,
  currency = "USD",
  variant = "default",
}) => {
  const classes = classNames("flex", "items-center", "justify-between", {
    "text-teal-600 font-semibold": variant === "green",
    "text-gray-600": variant === "default",
  })

  return (
    <div className={classes}>
      {source === "dockwa_plus" ? (
        <DockwaPlusBadge label={label} />
      ) : (
        <span>{label}</span>
      )}
      <span>{formatCurrencyFromMinorUnits({ amount, currency })}</span>
    </div>
  )
}

Discount.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  source: PropTypes.string,
  currency: PropTypes.string,
  variant: PropTypes.string,
}

export default Discount
